import { registerPlugin } from '@capacitor/core';
const AppConfig = registerPlugin('MDMAppConfig', {});
export * from './definitions';
export { AppConfig };
//# sourceMappingURL=index.js.map